export default "__VITE_ASSET__BR8x_VtF__"